import { ref } from 'vue';
const loadingProductId = ref(null);

export function useCartLoading() {
  const setLoading = (productId) => {
    loadingProductId.value = productId;
  };

  const clearLoading = () => {
    loadingProductId.value = null;
  };

  const isLoading = (productId) => {
    return loadingProductId.value === productId;
  };

  const isAnyLoading = () => {
    return loadingProductId.value !== null;
  };

  return {
    loadingProductId,
    setLoading,
    clearLoading,
    isLoading,
    isAnyLoading,
  };
}

